import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { InventorySliceState } from "../../utils/inventory.types";
import { ApiStatus } from "../../utils/api.types";
import { addInventory, deleteInventory, fetchInventories, updateInventory, fetchInventoryById, fetchInventoryByAccountId, AdjustStockBySkuId } from "./inventoryThunk";

/**
 * Invoice slice initial state.
 */
const initialState: InventorySliceState = {
    inventories: [],
    rowCount: 0,
    inventoryDeatils: {},
    errorMessage: '',
    isInventoryCreated: false,
    selectedInventoryId: '',
    status: ApiStatus.IDLE
}

/**
 * Inventory Slice.
 */
const inventorySlice = createSlice({
    name: 'inventory',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // Fetch Inventories
            .addCase(fetchInventories.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchInventories.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.inventories = action?.payload.inventories || [];
                state.rowCount = action?.payload?.total || [];
                state.errorMessage = '';
            })

            .addCase(fetchInventories.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Fetch Inventory by Account ID
            .addCase(fetchInventoryByAccountId.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchInventoryByAccountId.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.inventories = action?.payload?.inventories || [];
                state.rowCount = action?.payload?.total || [];
                state.errorMessage = '';
            })
            .addCase(fetchInventoryByAccountId.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Fetch Inventory by ID
            .addCase(fetchInventoryById.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchInventoryById.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.inventoryDeatils = action?.payload || [];
                state.errorMessage = '';
            })
            .addCase(fetchInventoryById.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Add Inventory
            .addCase(addInventory.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(addInventory.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.isInventoryCreated = true;
                state.inventories.push(action.payload.invoice);
                state.errorMessage = '';

                toast.success(action.payload.message);
            })
            .addCase(addInventory.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.isInventoryCreated = false;
                state.errorMessage = action.error.message
            })

            // Delete Inventories
            .addCase(deleteInventory.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(deleteInventory.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                state.errorMessage = '';

                const { id, message } = action.payload;
                state.inventories = state.inventories.filter(item => item._id !== id)

                toast.success(message);
            })
            .addCase(deleteInventory.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message

                toast.success(state.errorMessage);
            })

            // Update Inventory
            .addCase(updateInventory.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(updateInventory.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                const { message, inventory: updateInventory } = action.payload
                state.inventories = state.inventories
                    .map(item => (item._id === item._id ? { ...item, ...updateInventory } : item));

                state.errorMessage = '';

                toast.success(message);
            })
            .addCase(updateInventory.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
            })

            // AdjustStockBySkuId
            .addCase(AdjustStockBySkuId.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(AdjustStockBySkuId.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                const { message, skuHistory: skuHistory } = action.payload
                toast.success(message);
            })
            .addCase(AdjustStockBySkuId.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
            })

            // AdjustStockBySkuId
    }
});

export default inventorySlice.reducer;
